import styled from 'styled-components';
import { useTheme } from 'styled-components';

const Wrap = styled.div<{ $size: number }>`
  position: relative;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex: 0 0 auto;
`;

const Value = styled.div<{ $urgent: boolean }>`
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 1.15rem;
  color: ${({ $urgent, theme }) => ($urgent ? theme.colors.danger : theme.colors.ink)};
  transition: color 300ms ease;
`;

interface CountdownRingProps {
  /** 1 → full, 0 → empty. */
  fraction: number;
  seconds: number;
  size?: number;
}

/** Circular timer. Turns pink and pulses once it drops under five seconds. */
export function CountdownRing({ fraction, seconds, size = 64 }: CountdownRingProps) {
  const theme = useTheme();
  const stroke = 7;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const urgent = seconds <= 5;

  return (
    <Wrap $size={size}>
      <svg width={size} height={size} aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={theme.colors.surfaceSunken}
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={urgent ? theme.colors.danger : theme.colors.lavenderDeep}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - fraction)}
          // Start the arc at 12 o'clock and drain clockwise.
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke 300ms ease' }}
        />
      </svg>
      <Value $urgent={urgent}>{seconds}</Value>
    </Wrap>
  );
}
